import React from 'react';
import { Select } from 'antd';
import { connect } from 'react-redux';

import { domainListLoad } from "store/models/domain";
import { FormItem } from "utils";
import { ListLoadComponent } from 'components/common';


const DomainSelect = (props) => {
  return (
    <ListLoadComponent
      apiLoad={domainListLoad}
      filter={{ parent__isnull: true, simple: true }}
      {...props}
      render={({ items }) => {
        const { onChange, disabled, router, authToken, model, dispatch, ...otherProps } = props;
        return (
          <FormItem {...otherProps}>
            <Select
              style={{ width: '100%' }}
              onChange={onChange}
              showSearch={true}
              optionFilterProp="children"
              filterOption={(input, option) => {
                console.log(option);
                const children = option.props.children;
                return children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }}
              disabled={disabled}
            >
              {!props.required && <Select.Option value={null}>---</Select.Option>}
              {items.map(item => (
                <Select.Option key={`domain${item.id}`} value={item.id}>
                  {item.domain}
                </Select.Option>
              ))}
            </Select>
          </FormItem>
        );
      }}
    />
  );
};

const mapState = state => ({
  router: state.router,
  authToken: state.auth.token,
  model: state.domain,
});

export default connect(mapState)(DomainSelect);
